// ColorWheel.tsx
import { useState } from 'react';
import { HslColorPicker } from "react-colorful";

// Define a type for HSL color
interface HSL {
  h: number; // Hue: 0–360
  s: number; // Saturation: 0–100
  l: number; // Lightness: 0–100
}

const ColorWheel = () => {
  // Initial color: red
  const [color, setColor] = useState<HSL>({ h: 0, s: 100, l: 50 });

  return (
    <></>
  );
};

export default ColorWheel;
